import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Tier } from '@/types';
import api from '@/api/client';
import { setTiers, editTier, removeTier } from '../slices/tierSlice';
import { setToast } from '../slices/toastSlice';

export const fetchTiers = createAsyncThunk('tier/fetch', async (_, { dispatch, rejectWithValue }) => {
  try {
    const { data } = await api.get<{ data: Tier[] }>('/tiers/');
    dispatch(setTiers(data.data ?? []));
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Erreur chargement tiers';
    dispatch(setToast({ message, severity: 'error' }));
    return rejectWithValue(message);
  }
});

export const createTier = createAsyncThunk<boolean, Partial<Tier>, { rejectValue: string }>(
  'tier/create',
  async (tier, { dispatch, rejectWithValue }) => {
    try {
      await api.post('/tiers/', tier);
      await dispatch(fetchTiers());
      dispatch(setToast({ message: 'Tier créé', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur création';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const updateTier = createAsyncThunk<boolean, Tier, { rejectValue: string }>(
  'tier/update',
  async (tier, { dispatch, rejectWithValue }) => {
    try {
      await api.put(`/tiers/${tier.id}`, tier);
      dispatch(editTier(tier));
      dispatch(setToast({ message: 'Tier modifié', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur modification';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const deleteTier = createAsyncThunk<boolean, number | Tier, { rejectValue: string }>(
  'tier/delete',
  async (idOrTier, { dispatch, rejectWithValue }) => {
    try {
      const id = typeof idOrTier === 'number' ? idOrTier : idOrTier.id;
      await api.delete(`/tiers/${id}`);
      dispatch(removeTier(id));
      dispatch(setToast({ message: 'Tier supprimé', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur suppression';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);
